export default __webpack_public_path__ + "static/media/roadmap.d47a24e2.svg";